//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import query from '~/queries/getProductDetail.graphql';

export default {
    props: ['skus'],
    async fetch() {
        if (!this.sku.length) {
            this.products = [];

            return;
        }
        const {
            data: {
                products: { items },
            },
        } = await this.$apollo.query({
            query,
            variables: {
                filter: { sku: { in: this.sku } },
                pageSize: 4,
            },
        });
        this.products = items;
    },
    data() {
        return {
            products: [],
        };
    },
    computed: {
        sku() {
            return this.skus.reduce((acc, curr) => {
                acc.push(curr.sku);

                return acc;
            }, []);
        },
    },
};
